import { render, staticRenderFns } from "./option-classes.pug?vue&type=template&id=a81eddb0&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./option-classes.scss?vue&type=style&index=0&id=a81eddb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81eddb0",
  null
  
)

export default component.exports